/*
 * @Author: llzq
 * @Date: 2020-12-12 14:30:21
 * @Email: liuzhiqiang1@jd.com
 * @LastEditors: llzq
 * @LastEditTime: 2021-10-24 13:50:31
 * @Description:  头部注释
 */
import React from "react"
import {Table as UITable} from "antd"
export default class Table<T> extends UITable<T> {
  render() {
    let { ...props } = this.props;
    return <UITable<T> {...props}></UITable>;
  }
}
